export { TouristicContentUI } from './TouristicContentUI';
